export const BLACKLIST_EXCLUDED_AD_IDS = [8, 15, 18, 3];
export const MAX_RECEIVE_AD_ATTEMPTS = 5;
